import { Chip, Link, Stack, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ContactChipProps } from './types';

type Props = {
  contact: ContactChipProps;
};

export const ContactChip: FC<Props> = ({ contact }) => {
  const { t } = useTranslation();
  const contactName = contact.label || `${contact.firstName} ${contact.lastName}`;

  return (
    <Tooltip
      placement="top"
      key={contact._id}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: 'background.default',
            color: 'text.primary',
            border: '1px solid',
            borderColor: 'text.disabled',
            padding: 2,
          },
        },
      }}
      title={
        <>
          <Stack>
            <Typography variant="h6">{contactName}</Typography>

            <Stack spacing={1} direction="row" alignItems="center">
              <Typography fontWeight="600" fontSize={12}>{`${t('Email')}:`}</Typography>
              <Link href={`mailto:${contact.email}`}>{contact.email}</Link>
            </Stack>

            <Stack spacing={1} direction="row" alignItems="center">
              <Typography fontWeight="600" fontSize={12}>{`${t('Phone Number')}:`}</Typography>
              {contact.phoneNumber === '' ? (
                '-'
              ) : (
                <Link href={`tel:${contact.phoneNumber}`}>{contact.phoneNumber}</Link>
              )}
            </Stack>

            <Stack spacing={1} direction="row" alignItems="center">
              <Typography fontWeight="600" fontSize={12}>{`${t('Position')}:`}</Typography>
              {contact.position ?? '-'}
            </Stack>
          </Stack>
        </>
      }
    >
      <Chip
        label={contactName}
        size="small"
        variant="outlined"
        color="default"
        sx={{ cursor: 'pointer' }}
      />
    </Tooltip>
  );
};
